// extracted by mini-css-extract-plugin
module.exports = {"footer":"StrrdFooter_footer__17aZd","button":"StrrdFooter_button__JvXvN"};